var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D16",
    d: "M20.487 24.5c-.187 0-.37-.043-.537-.128L14 21.257l-5.95 3.115a1.167 1.167 0 01-1.692-1.237l1.167-6.568L2.718 11.9a1.167 1.167 0 01-.291-1.167c.138-.423.504-.73.945-.793l6.65-.968 2.928-5.985a1.167 1.167 0 012.1 0l2.963 5.973 6.65.968c.44.063.807.37.945.794.127.413.014.861-.291 1.166l-4.807 4.667 1.167 6.568c.085.447-.097.902-.467 1.167a1.167 1.167 0 01-.723.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcStar);
export default __webpack_public_path__ + "static/media/icon_ic_star.2ebae17b66584fe0023f4574d66ec4fd.svg";
export { ForwardRef as ReactComponent };